<template>
  <div :class="{ 'pb-12 xl:pb-16': !dataSet }">
    <ul
      class="grid w-full grid-cols-3 gap-2 md:flex md:max-w-3xl md:justify-start md:gap-3"
    >
      <li
        v-for="(item, idx) in data"
        :key="idx"
        class="flex flex-col items-start gap-1 sm:flex-row sm:items-center sm:gap-1.5"
        :class="[
          { 'text-grey-100': greenBg },
          { 'text-white': darkBg },
          { 'text-grey-900': !greenBg && !darkBg },
        ]"
      >
        <component
          :is="item.icon"
          class="size-3 shrink-0"
          :class="[
            { 'fill-lemon-200': greenBg },
            { 'fill-grey-50': darkBg },
            { 'fill-green-700': !greenBg && !darkBg },
          ]"
        />
        <div class="text-left">
          <NuxtLink
            v-if="item.link"
            :to="item.link"
            :external="true"
            target="_blank"
            class="text-xs lg:text-sm"
            :class="{ 'text-white': greenBg || darkBg }"
            >{{ item.name }}</NuxtLink
          >
          <p v-else class="mb-0 text-xs lg:text-sm">
            {{ item.name }}
          </p>
        </div>
      </li>
    </ul>
    <p v-if="dataSet" class="pb-3 pt-12 text-xs text-white lg:text-sm xl:pt-16">
      <NuxtLink
        to="https://www.roymorgan.com/findings/9758-trusted-brand-awards-2024-services-brands-and-companies"
        target="_blank"
        class="text-current"
        >†Roy Morgan Telco satisfaction</NuxtLink
      >. ^Reviews taken from ProductReview, Facebook & Google.
    </p>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  dataSet?: UspSet; // Common set of USPs
  data?: UspData[]; // Unique set of USPs
  greenBg?: boolean;
  darkBg?: boolean;
}>();

export type UspSet = "generic";

export interface UspData {
  name: string;
  icon: Component | string;
  link?: string;
}

const uspData: {
  [key in UspSet]: UspData[];
} = {
  generic: [
    {
      name: "Australia's Most Trusted†",
      icon: resolveComponent("IconSocialThumbsUp"),
    },
    {
      name: "100% Australian based",
      icon: resolveComponent("IconAustralianBased"),
    },
    {
      name: "4.6/5 from 10k+ reviews^",
      icon: resolveComponent("IconStar"),
    },
  ],
};

const data = uspData[props.dataSet!] ?? props.data;
</script>
